import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const NotFound = lazy(() => import('../pages/NotFound'));
const HomePage = lazy(() => import('../pages/home/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
